(function() {
  var el = document.getElementById('delivery-countdown');
  if (!el) return;


  // --- KØBENHAVN TID ---
  function getCopenhagenNow() {
    var now = new Date();
    var cphString = now.toLocaleString('en-US', { timeZone: 'Europe/Copenhagen' });
    return new Date(cphString);
  }

  // --- CUT-OFF TIDER (KØBENHAVN TID) ---
  var CUT_OFF_MON_THU = { h: 14, m: 30 };
  var CUT_OFF_FRI     = { h: 14, m: 0 };

  // --- TEKSTER ---
  var TEXT_MON_THU_BEFORE = 'Levering i morgen - Bestil inden:';
  var TEXT_MON_THU_AFTER  = 'Levering i overmorgen - Bestil inden:';
  var TEXT_FRI_BEFORE     = 'Levering i morgen (pakkeshop) - Bestil inden:';

  function makeDate(year, month, day) {
    return new Date(year, month, day);
  }

  function getEasterSunday(year) {
    var a = year % 19;
    var b = Math.floor(year / 100);
    var c = year % 100;
    var d = Math.floor(b / 4);
    var e = b % 4;
    var f = Math.floor((b + 8) / 25);
    var g = Math.floor((b - f + 1) / 3);
    var h = (19 * a + b - d - g + 15) % 30;
    var i = Math.floor(c / 4);
    var k = c % 4;
    var l = (32 + 2 * e + 2 * i - h - k) % 7;
    var m = Math.floor((a + 11 * h + 22 * l) / 451);
    var month = Math.floor((h + l - 7 * m + 114) / 31);
    var day = ((h + l - 7 * m + 114) % 31) + 1;
    return new Date(year, month - 1, day);
  }

  function addDays(date, days) {
    var d = new Date(date);
    d.setDate(d.getDate() + days);
    return d;
  }

  function isSameDate(d1, d2) {
    return d1.getFullYear() === d2.getFullYear() &&
           d1.getMonth() === d2.getMonth() &&
           d1.getDate() === d2.getDate();
  }

  function isDanishHoliday(date) {
    var year = date.getFullYear();
    var month = date.getMonth();
    var day = date.getDate();

    if (
      (month === 11 && day >= 18) ||
      (month === 0 && day <= 4)
    ) {
      return true;
    }

    var newYearsDay  = makeDate(year, 0, 1);
    var christmasEve = makeDate(year, 11, 24);
    var christmasDay = makeDate(year, 11, 25);
    var boxingDay    = makeDate(year, 11, 26);

    if (isSameDate(date, newYearsDay) ||
        isSameDate(date, christmasEve) ||
        isSameDate(date, christmasDay) ||
        isSameDate(date, boxingDay)) {
      return true;
    }

    var easterSunday    = getEasterSunday(year);
    var maundyThursday  = addDays(easterSunday, -3);
    var goodFriday      = addDays(easterSunday, -2);
    var easterMonday    = addDays(easterSunday, 1);
    var ascensionDay    = addDays(easterSunday, 39);
    var pentecostMonday = addDays(easterSunday, 50);

    var moving = [maundyThursday, goodFriday, easterMonday, ascensionDay, pentecostMonday];

    for (var i = 0; i < moving.length; i++) {
      if (isSameDate(date, moving[i])) return true;
    }

    return false;
  }

  function createCutoffDate(baseDate, cutoff) {
    var d = new Date(baseDate);
    d.setHours(cutoff.h, cutoff.m, 0, 0);
    return d;
  }

  function getMessageAndDeadline(nowCph) {
    var day = nowCph.getDay();
    var deadline = null;
    var text = '';
    var show = true;

    if (isDanishHoliday(nowCph)) {
      return { text: '', deadline: null, show: false };
    }

    if (day >= 1 && day <= 4) {
      deadline = createCutoffDate(nowCph, CUT_OFF_MON_THU);
      if (nowCph < deadline) {
        text = TEXT_MON_THU_BEFORE;
      } else {
        var nextDay = new Date(nowCph);
        nextDay.setDate(nowCph.getDate() + 1);
        deadline = createCutoffDate(nextDay, CUT_OFF_MON_THU);
        text = TEXT_MON_THU_AFTER;
      }
    } else if (day === 5) {
      deadline = createCutoffDate(nowCph, CUT_OFF_FRI);
      if (nowCph < deadline) {
        text = TEXT_FRI_BEFORE;
      } else {
        show = false;
      }
    } else {
      show = false;
    }

    return { text: text, deadline: deadline, show: show };
  }

  function formatTimeDiff(ms) {
    if (ms <= 0) return null;
    var totalSeconds = Math.floor(ms / 1000);
    var hours = Math.floor(totalSeconds / 3600);
    var minutes = Math.floor((totalSeconds % 3600) / 60);
    var seconds = totalSeconds % 60;
    function pad(n) { return n < 10 ? '0' + n : n; }
    return hours + 't ' + pad(minutes) + 'm ' + pad(seconds) + 's';
  }

  function tick() {
    var nowCph = getCopenhagenNow();
    var data = getMessageAndDeadline(nowCph);

    if (!data.show || !data.deadline) {
      el.innerHTML = '';
      el.style.display = 'none';
      return;
    }

    var diff = data.deadline - nowCph;
    var countdown = formatTimeDiff(diff);

    if (!countdown) {
      el.innerHTML = '';
      el.style.display = 'none';
      return;
    }

   el.style.display = 'block';
el.innerHTML = data.text + '<br><strong>' + countdown + '</strong>';
  }

  tick();
  setInterval(tick, 1000);
})();